<template lang="pug">
    .guest-footer-control
        .guest-footer-control__item(v-for="item in items" @click="itemClick(item)" :class="getItemClass(item)")
            a(v-if="item.link" :href="item.link" target="_blank") {{ item.text }}
            span(v-else) {{ item.text }}
</template>

<script>
import Moment from 'moment'
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import ModalsList from '../../components/modals/modals-list'

export default {
    name: 'guest-footer-control',

    computed: {
        items() {
            return [
                {
                    text: 'Blog',
                    link: '/blog',
                },
                {
                    text: 'FAQ',
                    link: '/faq',
                },
                {
                    text: 'Privacy Policy',
                    link: '/privacy-policy',
                },
                {
                    text: 'Terms of Use',
                    link: '/terms-of-use',
                },
                {
                    text: 'Terms of Sale',
                    link: '/terms-of-sale',
                },
                {
                    text: 'GDPR Cookie Policy',
                    link: '/cookie-policy',
                },
                {
                    text: 'GDPR Info Request',
                    click: () => {
                        EventBus.$emit(Events.OPEN_MODAL, ModalsList.GDPR_REQUEST)
                    },
                },
                {
                    text: `© ${Moment().year()} GotMeHookd All rights reserved`,
                },
            ]
        },
    },

    methods: {
        itemClick(item) {
            if (item.click) {
                item.click()
            }
        },

        getItemClass(item) {
            return {
                'guest-footer-control__item--clickable': !!item.click,
            }
        },
    }
}
</script>
